import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'start',
        flexWrap: "wrap"
    },
    header: {
        color: theme.palette.text.primary,
        textAlign: 'center'
    }
}));

export {useStyles};